import { render, staticRenderFns } from "./ProductEffectsList.vue?vue&type=template&id=652f446d&scoped=true"
import script from "./ProductEffectsList.vue?vue&type=script&lang=js"
export * from "./ProductEffectsList.vue?vue&type=script&lang=js"
import style0 from "./ProductEffectsList.vue?vue&type=style&index=0&id=652f446d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652f446d",
  null
  
)

export default component.exports